module.exports = __webpack_public_path__ + "static/scale-model-of-cincinnati-zoo-&-botanical-garden-in-cincinnati-ohio-0615cbcbc2efb198cc32dd78a5dc9656.png";